import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-accent text-brand-dark py-2.5 px-3 shadow-[0_0_20px_rgba(0,191,255,0.2)] relative z-20" data-id="element-204">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[10px] md:text-xs font-black text-center" data-id="element-205">
        <div className="flex items-center" data-id="element-206">
          <Users className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-207" />
          <span data-id="element-208">+2.000 entrenadores confían</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-209">|</span>
        <div className="flex items-center" data-id="element-210">
          <BookCopy className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-211" />
          <span data-id="element-212">6 tomos</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-213">|</span>
        <div className="flex items-center" data-id="element-214">
          <Star className="w-3 h-3 md:w-4 md:h-4 mr-1 fill-current" data-id="element-215" />
          <span data-id="element-216">4,9/5 calificación</span>
        </div>
        <span className="hidden md:inline opacity-50" data-id="element-217">|</span>
        <div className="flex items-center" data-id="element-218">
          <Globe className="w-3 h-3 md:w-4 md:h-4 mr-1" data-id="element-219" />
          <span data-id="element-220">Todo el mundo hispanohablante</span>
        </div>
      </div>
    </div>;
}